export default __webpack_public_path__ + "media/image_editor/js/interface/widgets/Spinner/mason_icon_red-19754c64757687ce5b3e13bae9763648.svg";